import React, { useState,useEffect,useContext } from 'react';
import { useLocation,useNavigate} from 'react-router-dom';
import {Country,State} from 'country-state-city';
import { PassContext } from '../../../../hooks/PassContext.js';
import axios from 'axios';
import './Billing.css';
import { Stepper } from './Stepper.js';
import { CART_BASE_URL } from '../../../../config/ApiConfig.js';
import { showNotification } from '../../../../services/NotificationService.js';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const Billing = () => {
    const [cartItems, setCartItems] = useState([]);
    const { types } =useContext(PassContext)
    const location= useLocation();
    const navigate=useNavigate();
    const [state,setState]=useState('');
    const [country,setCountry]=useState('US');
    const { cartId,cartGUID,hasAnnualPass} = location.state;
    const [billingDetails, setBillingDetails] = useState({
        billingFirstName: '',
        billingLastName: '',
        billingAddress1: '',
        billingAddress2: '',
        billingCity: '',
        state: '',
        billingZip: '',
        country: '',
    });
    const[paymentDetail,setPaymentDetail]=useState({
        cardHolder:'',
        cardNumber:'',
        cvv:'',
        month:'',
        year:''
    })
    const [errorsData, setErrorsData] = useState({});
    const [paymentErrors,setPaymentErrors] = useState({});
    const [shippingData,setShippingData] = useState({});
    const [checkbox,setCheckbox]= useState(false);
    const [isSameAsShipping, setIsSameAsShipping] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formError,setFormError]=useState('');
    useEffect(() => {
        setErrorMessage('')
        fetchOrderDetails();
        shippingDetails();
    }, [cartId,cartGUID]);
    const fetchCartDetailsAPI = async (cartGUID) => {
        try {
            const response = await axios.get(`${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`);
            const passes = response.data.data.cartDetails.passes;
            const cartItemDetails =  response.data.data.cartDetails;
            const cId = response.data.data.cartDetails.cartID;
            const shippingInformation = response.data.data.cartDetails.shippingDetails || {};
            return [passes,cartItemDetails,cId,shippingInformation];
        } catch (error) {
            console.error("Error fetching cart details:", error);
            setErrorMessage(`Sorry, we're unable to load billing page at the moment. Please try refreshing the page or come back later.`);
        }
    };

    const fetchOrderDetails = async () => {
        try {
            if(cartGUID){
                const [passes, cartItemDetails] = await fetchCartDetailsAPI(cartGUID);
                const cartDetails = cartItemDetails;
                const orderDetails = cartDetails;
                const savedResponseForCart = passes;
                // Filter types to only include passes that exist in savedResponseForCart
                const filteredTypes = types.filter(type => 
                    savedResponseForCart.some(order => order.passID === type.passID)
                );
                const mergedOrdersData = filteredTypes.map(type => {
                    // Find the first matching order for this passID in savedResponseForCart
                    const matchingOrder = savedResponseForCart.find(order => order.passID === type.passID);   
                    // Combine type data with the matching order information
                    return {
                        ...type,
                        quantity: matchingOrder ? matchingOrder.quantity : 0,
                        passDate: matchingOrder ? matchingOrder.passDate : null,
                    };
                });
                setCartItems(mergedOrdersData);
                //This condition is used when we have both the passes and then we remove the annual Pass nd left with one-day Pass.With this condition checkbox is not shown
                if(mergedOrdersData.passID!==1){
                    setIsSameAsShipping(false);
                }
                // Populate billing details from API response
                if (orderDetails.billingDetails) {
                    setBillingDetails({
                        billingFirstName: orderDetails.billingDetails.billingFirstName || '',
                        billingLastName: orderDetails.billingDetails.billingLastName || '',
                        billingAddress1: orderDetails.billingDetails.billingAddress1 || '',
                        billingAddress2: orderDetails.billingDetails.billingAddress2 || '',
                        billingCity: orderDetails.billingDetails.billingCity || '',
                        state: orderDetails.billingDetails.billingState || '',
                        billingZip: orderDetails.billingDetails.billingZip || '',
                        country: orderDetails.billingDetails.billingCountry || 'US',
                    });
                    setState(orderDetails.billingDetails.billingState || '');
                    setCountry(orderDetails.billingDetails.billingCountry || 'US');
                    setIsSameAsShipping(orderDetails.billingDetails.sameAsShipping);
                }
            }
        } catch (error) {
            console.error('Error fetching order details:', error);
            showNotification("Oops! Something went wrong. Please try again later.","error");
        }
    };

    const checkboxHandler = () => {
        const newIsSameAsShipping = !isSameAsShipping;
        setIsSameAsShipping(newIsSameAsShipping);
        if (newIsSameAsShipping) {
            shippingDetails();
        }
        setCheckbox(!checkbox);
    };
    const shippingDetails = async () => {
        try{
            const [,,,shippingInformation] = await fetchCartDetailsAPI(cartGUID);
            const shippingDetails = shippingInformation;
            setShippingData(shippingDetails);  // Update the state
        }catch(error){
            console.error(error);
        }
    };
    const handleChange = (event) => {
        const { name, value } = event.target;
        const updatedDetails = { ...billingDetails, [name]: value };
        setBillingDetails(updatedDetails);
        // Remove error for the specific field when user starts typing
        if (errorsData[name]) {
            setErrorsData({ ...errorsData, [name]: value.trim() ? '' : errorsData[name] });
        }
    };
    const paymentHandler=(event)=>{
        const { name, value } = event.target;
        const updatedPaymentDetails = {...paymentDetail,[name]:value};
        setPaymentDetail(updatedPaymentDetails);
        // Remove error for the specific field when user starts typing
        if (paymentErrors[name]) {
            setPaymentErrors({ ...paymentErrors, [name]: value.trim() ? '' : paymentErrors[name] });
        }
    }
    const handleStateChange = (e) => {
        const selectedState = e.target.value;
        setState(selectedState);
        // Manually create the updated details object
        const updatedDetails = {
            ...billingDetails,
            state: selectedState, // Update billing State directly
        };
        setBillingDetails(updatedDetails);
        // Remove error if the state field is filled
        if (errorsData.state) {
            setErrorsData({ ...errorsData, state: selectedState ? '' : errorsData.state });
        }
    };
    const handleCountryChange = (e) => {
        const selectedCountry = e.target.value;
        setCountry(selectedCountry);

        setBillingDetails(prev => ({
            ...prev,
            billingZip: '',
            state:''
        }));

        setErrorsData(prev => {
            const { billingZip, ...rest } = prev;
            return rest;
        });
    };
    // Validation rules
    const validate = () => {
        const newErrors = {};
        const { billingFirstName, billingLastName, billingAddress1, billingCity, billingZip,state } = billingDetails;
        let isValid = true;
        // Check if the cart contains only the one-day pass
             // Full validation for other shipping details
        if (!billingFirstName.trim()) { // Updated regex
            newErrors.billingFirstName = 'First name is must';
            isValid = false;
        }
        if (!billingLastName.trim()) { // Updated regex
            newErrors.billingLastName = 'Last name is must';
            isValid = false;
        }
        if (!state.trim()) {
            newErrors.state = 'State is required.';
            isValid = false;
        }
        if (!/^[a-zA-Z0-9\s,.-]{3,}$/.test(billingAddress1)) {
            newErrors.billingAddress1 = 'Address must contain at least 3 characters.';
            isValid = false;
        }
        if (!/^(?!\s)[A-Za-z\s]{1,}$/.test(billingCity)) {
            newErrors.billingCity = 'City must contain at least 1 or more non-whitespace characters.';
            isValid = false;
        }
        const countryInfo = Country.getCountryByCode(country);
            const zipRegex = countryInfo.isoCode !== 'CA'? /^\d{5}(-\d{4})?$/: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
            if (!zipRegex.test(billingZip)) {
                if (countryInfo.isoCode === 'CA') {
                    newErrors.billingZip = `ZIP code must match the format: A1A 1A1 for ${countryInfo.name}.`;
                } else {
                    newErrors.billingZip = `ZIP code must follow the format: 12345 for ${countryInfo.name}.`;
                }
                isValid = false;
            }
        if (!isValid) {
            setFormError('Please check the forms and ensure all the required fields are completed.');
            setTimeout(() => {
                const formStart = document.getElementById('formStartsAt');
                if (formStart) {
                    formStart.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100); // Smooth scroll to form section
        } else {
            setFormError('');
        }
        setErrorsData(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const validatePayment = () => {
        const paymentErrors = {}; 
        let isValid=true
        // Card Holder Name Validation
        if (!/^(?!\s)[A-Za-z\s]{3,}$/.test(paymentDetail.cardHolder)) {
            paymentErrors.cardHolder = 'Name on card must be at least 3 characters and only contain letters and spaces.';
            isValid=false;
        }    
        // Card Number Validation
        if (!/^\d{16}$/.test(paymentDetail.cardNumber)) {
            paymentErrors.cardNumber = 'Card number must be a 16-digit number.';
            isValid=false;
        }    
        // CVV Validation
        if (!/^\d{3}$/.test(paymentDetail.cvv)) {
            paymentErrors.cvv = 'CVV must be a 3-digit number.';
            isValid=false;
        }   
        if(!paymentDetail.month.trim()){
            paymentErrors.month = 'Month is required.';
            isValid=false;
        } 
        if(!paymentDetail.year.trim()){
            paymentErrors.year = 'Year is required.';
            isValid=false;
        } 
        if (!isValid) {
            setFormError('Please check the forms and ensure all the required fields are completed.');
            setTimeout(() => {
                const formStart = document.getElementById('formStartsAt');
                if (formStart) {
                    formStart.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100); // Smooth scroll to form section
        } else {
            setFormError('');
        }
        setPaymentErrors(paymentErrors);
        return Object.keys(paymentErrors).length === 0;
    };
    const formSubmitHandler = async (event) => {
        event.preventDefault();
        // Prepare billing data based on isSameAsShipping
        let billingData;
        if (isSameAsShipping && cartItems.some(item => item.passID === 1)) {
            billingData = {
                cartID: cartId,
                billingFirstName: shippingData.shippingFirstName,
                billingLastName: shippingData.shippingLastName,
                billingAddress1: shippingData.shippingAddress1,
                billingAddress2: shippingData.shippingAddress2,
                billingCity: shippingData.shippingCity,
                billingState: shippingData.shippingState,
                billingZip: shippingData.shippingZip,
                billingCountry: shippingData.shippingCountry,
                sameAsShipping:isSameAsShipping
            };
        } else {
            // Validate the billing details
            const isValid = validate();
            if (!isValid) {
                return; // Exit if validation fails
            }
            // Set billing data from the input fields
            billingData = {
                cartID: cartId,
                billingFirstName: billingDetails.billingFirstName,
                billingLastName: billingDetails.billingLastName,
                billingAddress1: billingDetails.billingAddress1,
                billingAddress2: billingDetails.billingAddress2,
                billingCity: billingDetails.billingCity,
                billingState: state,
                billingZip: billingDetails.billingZip,
                billingCountry: country,
                sameAsShipping:isSameAsShipping === '' || cartItems.some(item => item.passID !== 1) ? false : isSameAsShipping
            };
        }
        const isPaymentValid = validatePayment();
        if (!isPaymentValid) return; // Exit if payment validation fails
        try {
            const response = await axios.post(`${CART_BASE_URL}/SaveUpdateBillingDetails`, billingData, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if(response.data.statusId===200){
               navigate('/review',{ state: { cartId,cartGUID,paymentDetail,hasAnnualPass } })
            }
        } catch (error) {
            console.log('Error while sending request:', error);
            showNotification("Unable to save or update the billing details at the moment. Please try again later.", "error");
        }
    };    
    const hasPassIdOne = cartItems.some(item => item.passID === 1);
    //Filter for Countries
    const allowedCountries = Country.getAllCountries().filter(
        (country) => country.isoCode === 'US' || country.isoCode === 'CA'
    );
    return(
        <>
            <div className='container-billing my-5'>
                <div className='main-billing'>
                    {errorMessage?<><h3 className='errorHandled'>{errorMessage}</h3></>:<>
                    <Stepper currentStep={2}></Stepper>
                    {
                        formError && 
                        <>  
                            <div className="errBox" style={{display: "block;"}}>{formError}</div>
                        </>
                    }
                    <form onSubmit={formSubmitHandler} style={{width:'100%'}}>
                        <>
                            <div className="checkout-cols d-flex justify-content-center">
                                <div className="checkout-col checkout-data">
                                    <h2 style={{marginBottom:'15px'}}>Billing Address</h2>
                                    {
                                        (hasAnnualPass || hasPassIdOne) && 
                                        <>
                                            <input style={{marginRight:"12px"}} type="checkbox" id="same-as-shipping" className="hiddenRadio" name="same-as-shipping" onClick={checkboxHandler}  checked={ isSameAsShipping}/>
                                            <label className="cbLabel hangingCheckbox" for="same-as-shipping">Same as shipping address.</label>
                                        </>
                                    }
                                    {
                                        ((hasAnnualPass || hasPassIdOne) && isSameAsShipping)?<>
                                            {
                                                Object.keys(shippingData).length > 0 ? 
                                                <>
                                                    <div className="shippingInfo">
                                                        <p>{shippingData.shippingFirstName} {shippingData.shippingLastName}<br/>
                                                            {shippingData.shippingAddress1} <br/>
                                                            {shippingData.shippingAddress2 && <>{shippingData.shippingAddress2},<br/></>}
                                                            {shippingData.shippingCity}, {shippingData.shippingState}, {shippingData.shippingZip}, <br/>
                                                            {shippingData.shippingCountry}  <br/>
                                                        </p>
                                                    </div>
                                                </>:
                                                <>
                                                    <div className="skeleton-wrapper d-flex flex-column">
                                                        <Skeleton height={30} width="100px" />
                                                        <Skeleton height={15} width="60%" />
                                                        <Skeleton height={15} width="50%" />
                                                        <Skeleton height={100} width="100%" />
                                                        <Skeleton height={30} width="40%" />
                                                        <Skeleton count={5} width="80%" />
                                                    </div>
                                                </>
                                            }
                                        </>:
                                        <>
                                        <label htmlFor="billingFirstName" className={errorsData.billingFirstName ? 'error-label' : ''}>First Name</label>
                                        <input type="text" name="billingFirstName" id="billingFirstName"      
                                        value={billingDetails.billingFirstName}
                                        onChange={handleChange}
                                        maxLength={40}
                                        className={`textEntry ${errorsData.billingFirstName ? 'error-input' : ''}`}></input>            
                                        <label htmlFor="billingLastName" className={errorsData.billingLastName ? 'error-label' : ''}>Last Name</label>
                                        <input
                                            type="text"
                                            name="billingLastName"
                                            value={billingDetails.billingLastName}
                                            onChange={handleChange}
                                            maxLength={40}
                                            className={`textEntry ${errorsData.billingLastName ? 'error-input' : ''}`}
                                        />            
                                        <label htmlFor="billingAddress" className={errorsData.billingAddress1 ? 'error-label' : ''}>Billing Address</label>
                                        <input
                                            type="text"
                                            name="billingAddress1"
                                            value={billingDetails.billingAddress1}
                                            maxLength={50}
                                            className={`textEntry ${errorsData.billingAddress1 ? 'error-input' : ''}`}
                                            onChange={handleChange}
                                        />           
                                        <label htmlFor="billingAddress2">Secondary Address</label>
                                        <input
                                            type="text"
                                            name="billingAddress2"
                                            className="textEntry"
                                            value={billingDetails.billingAddress2}
                                            onChange={handleChange}
                                            id="billingAddress2"
                                            maxLength={50}
                                        />            
                                        <label htmlFor="billingCity" className={errorsData.billingCity ? 'error-label' : ''}>City</label>
                                        <input
                                            type="text"
                                            name="billingCity"
                                            className={`textEntry ${errorsData.billingCity ? 'error-input' : ''}`}
                                            value={billingDetails.billingCity}
                                            onChange={handleChange}
                                            maxLength={50}
                                        />
                                        <label className={errorsData.state ? 'error-label' : ''}>State/Province/Region</label>
                                        <select
                                                className={`textEntry text-select ${errorsData.state ? 'error-input' : ''}`}
                                                name="billingState"
                                                value={state}
                                                onChange={handleStateChange}
                                            >
                                                <option value="selected"> Select a State</option>
                                                {State.getStatesOfCountry(country).map((stateItem) => (
                                                    <option key={stateItem.isoCode} value={stateItem.isoCode}>
                                                        {stateItem.name}
                                                    </option>
                                                ))}
                                            </select>
                                            <label htmlFor="billingZip" className={errorsData.billingZip ? 'error-label' : ''}>ZIP/Postal Code</label>
                                                <input
                                                    type="text"
                                                    name="billingZip"
                                                    value={billingDetails.billingZip}
                                                    onChange={handleChange}
                                                    maxLength={country === 'CA' ? 7 : 5}
                                                    className={`textEntry ${errorsData.billingZip ? 'error-input' : ''}`}
                                                    onKeyPress={(e) => {
                                                        const isCA = country === 'CA';
                                                        const key = e.key;
                                                        if (isCA) {
                                                            if (!/[A-Za-z0-9 ]/.test(key)) {
                                                                e.preventDefault();
                                                            }
                                                        } else {
                                                            if (!/[\d-]/.test(key)) {
                                                                e.preventDefault();
                                                            }
                                                        }
                                                    }}
                                                    onInput={(e) => {
                                                        let value = e.target.value;
                                                        if (country !== 'CA') {  
                                                            value = value.replace(/\D/g, '');// Remove all non-digit
                                                            if (value.length > 5) {
                                                                value = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
                                                            }
                                                            e.target.value = value;
                                                        }
                                                    }}
                                                />
                                                {errorsData.billingZip && <span className="error-text">{errorsData.billingZip}</span>}            
                                            <label htmlFor="billingCountry">Country</label>           
                                            <select
                                                className="textEntry text-select"
                                                name="billingCountry"
                                                value={country}
                                                onChange={handleCountryChange}
                                            >
                                                {allowedCountries.map((countryItem) => (
                                                    <option key={countryItem.isoCode} value={countryItem.isoCode}>
                                                        {countryItem.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </>
                                    }
                                </div>
                                <div className="checkout-divider"></div>
                                <div className="checkout-col checkout-data">
                                    <h2 style={{marginBottom:"15px"}}>Payment Details</h2>
                                    <p>We accept <strong>VISA</strong> and <strong>MasterCard</strong>.</p>
                                    <label htmlFor="nameOnCard" className={paymentErrors.cardHolder?'error-label':''}>Name on Card</label>
                                    <input type="text" className={`textEntry  ${paymentErrors.cardHolder ? 'error-input' : ''}`} name="cardHolder" id="nameOnCard"  value={paymentDetail.cardHolder} onChange={paymentHandler} minLength="3" maxLength="50" placeholder="Card Holder Name"/>
                                    {/* {paymentErrors.cardHolder && <span className="error-text">{paymentErrors.cardHolder}</span>} */}
                                    <label htmlFor="cardNumber" className={paymentErrors.cardNumber?'error-label':''}>Card Number</label>
                                    <input className={`textEntry  ${paymentErrors.cardNumber ? 'error-input' : ''}`}  id="ccNum" name="cardNumber"  type="tel" value={paymentDetail.cardNumber} onChange={paymentHandler}   
                                    maxLength="16" placeholder="Enter 16-digit card number" onKeyPress={(e) => {
                                        if (!/^\d$/.test(e.key)) {
                                            e.preventDefault(); // Prevent non-digit characters
                                        }
                                    }}/>
                                    {/* {paymentErrors.cardNumber && <span className="error-text">{paymentErrors.cardNumber}</span>} */}
                                    <label htmlFor="cvv" className={paymentErrors.cvv?'error-label':''}>CVV</label>
                                    <div style={{display:'flex'}}>
                                        <input className={`textEntry  ${paymentErrors.cvv ? 'error-input' : ''}`} id="ccCVV" name="cvv" type="tel" value={paymentDetail.cvv} onChange={paymentHandler}  maxLength="3" placeholder="CVV" onKeyPress={(e) => {
                                            if (!/^\d$/.test(e.key)) {
                                                e.preventDefault(); // Prevent non-digit characters
                                            }
                                        }}/>
                                        <p className={` cvvData ${paymentErrors.cvv?'error-label':''}`} style={{display:"inline-block",letterSpacing:'-1px', margin:'0px 0px 0px 10px'}}>CVV is the three-digit code on the back of your card.</p>
                                    </div>
                                    {/* {paymentErrors.cvv && <span className="error-text">{paymentErrors.cvv}</span>} */}
                                    <label htmlFor="ccMonth" className={(paymentErrors.month || paymentErrors.year)?'error-label':''}>Expiration Date</label>
                                    <select className={`prettyDropdown ${paymentErrors.month ? 'error-input' : ''}`} id="ccMonth" name="month"  value={paymentDetail.month} onChange={paymentHandler}>
                                        <option disabled value="">MM</option>
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                    <select className={`prettyDropdown ${paymentErrors.year ? 'error-input' : ''}`} id="ccYear" name="year" 
                                    value={paymentDetail.year} onChange={paymentHandler}>
                                    <option disabled value="">YY</option>
                                    {
                                        Array.from({ length: 13 }, (_, index) => {
                                        const year = new Date().getFullYear() + index;
                                        const shortYear = String(year).slice(-2); 
                                        return (
                                            <option key={year} value={shortYear}>
                                                {shortYear}
                                            </option>
                                        );
                                        })
                                    }
                                    </select>
                                </div>
                            </div>
                            <input type="submit" value="Continue" className="add-button add-button-continue billing-submit" />
                        </>
                    </form>
                    </>}
                </div>
            </div>
        </>
    )  
};